
export type GetAdminAccountPaymentSummaries200ItemAppGroupsItemSummariesItem = {
  /** @nullable */
  billingCycle?: string | null;
  /** @nullable */
  expiresAt?: string | null;
  /**
   * 관리자 UI 표시용 실패 분류
   * @nullable
   */
  failureCategory?: string | null;
  /**
   * 결제 플랫폼 (예: NICEPAY, GOOGLE_PLAY)
   * @nullable
   */
  paymentPlatform?: string | null;
  /** @nullable */
  planLabel?: string | null;
  primary: boolean;
  /** @nullable */
  productPlanCode?: string | null;
  /** @nullable */
  status?: string | null;
};
